import resultsPlaceholder from '@/assets/images/icons/results-placeholder.svg'
import ozAmount from '@/components/filters/oz-amount'
import ozAreas from '@/components/filters/oz-areas'
import ozPrices from '@/components/filters/oz-prices'
import ozAmenities from '@/pages/results/components/filters/components/oz-amenities'
import ozToggle from '@/components/oz-toggle'
import ozToggleZapway from '@/components/filters/oz-toggle-zapway'
import ozToggleDatazap from '@/components/filters/oz-toggle-datazap'
import ozToggleDisplayAddressType from '@/components/filters/oz-toggle-display-address-type'
import ozDevelopmentType from '@/pages/results/components/filters/components/oz-development-type'

import emptyFilters from './constants'

export default {
  name: 'oz-no-results',

  props: {
    primaryHeading: { type: String, required: true },
    alignText: { type: String, default: 'center' },
    filters: { type: Object, required: true },
  },

  data () {
    return {
      emptyFilters,
      resultsPlaceholder,
    }
  },

  computed: {
    hasFilters () {
      const emptyFiltersKeys = Object.keys(this.emptyFilters)

      const findFilter = emptyFiltersKeys.reduce((filters, item) => {
        const matched = emptyFilters[item]
        const valueFilter = this.filters[item]
        if (valueFilter && valueFilter !== matched) filters.push({ [item]: valueFilter })
        return filters
      }, [])

      return findFilter.length
    },

    hasVirtualTour () {
      const { hasVirtualTour } = this.filters
      return Boolean(hasVirtualTour)
    },
  },

  methods: {
    cleanFilters () {
      this.onFiltersUpdate(emptyFilters, 'clearAllFilters')
    },

    onFiltersUpdate (filters, filterName) {
      this.$emit('filters:update', filters, filterName)
    },

    onVirtualTourChange (value) {
      this.onFiltersUpdate({ hasVirtualTour: value }, 'hasVirtualTour')
    },
  },

  components: {
    ozAmount,
    ozAreas,
    ozPrices,
    ozToggle,
    ozToggleZapway,
    ozToggleDatazap,
    ozToggleDisplayAddressType,
    ozAmenities,
    ozDevelopmentType,
  },
}
